<div class="min-h-[100dvh] bg-[#fcfaf7] flex flex-col font-sans text-[#1f1b16]">
  <header class="sticky top-0 z-20 border-b border-black/[0.03] bg-[#fcfaf7]/95 backdrop-blur-md">
    <div class="mx-auto flex max-w-2xl items-center justify-between px-4 py-3 sm:py-4">
      <button
        type="button"
        (click)="goToSplit()"
        class="text-sm font-bold text-[#3a332c]/60 transition hover:text-black active:scale-95"
      >
        ← <span class="hidden xs:inline">Inicio</span>
      </button>

      <h1 class="text-base sm:text-lg font-bold tracking-tight">División compartida</h1>

      <div class="w-12"></div>
    </div>
  </header>

  <main class="flex-1 mx-auto w-full max-w-2xl px-4 py-6 space-y-6">
    @if (loading()) {
      <section
        class="rounded-3xl border border-black/[0.05] bg-white px-5 py-12 text-center shadow-sm"
      >
        <div
          class="inline-block animate-spin rounded-full h-8 w-8 border-4 border-orange-500/20 border-t-orange-500 mb-4"
        ></div>
        <p class="text-sm font-bold text-[#3a332c]/50 uppercase tracking-widest">
          Cargando división...
        </p>
      </section>
    }

    @if (error()) {
      <section
        class="rounded-3xl border border-red-100 bg-red-50/50 px-5 py-6 shadow-sm text-center"
      >
        <div class="text-3xl mb-3">⚠️</div>
        <p class="text-sm font-bold text-red-600 uppercase tracking-tight">{{ error() }}</p>
        <button (click)="goToSplit()" class="mt-4 text-xs font-bold text-red-700/60 underline">
          Volver al inicio
        </button>
      </section>
    }

    @if (summary(); as data) {
      <section
        class="rounded-[2rem] border border-black/[0.05] bg-white px-5 py-6 shadow-sm animate-in fade-in slide-in-from-bottom-3 duration-500"
      >
        <div class="space-y-1 mb-6 text-center">
          <h2 class="text-2xl font-black tracking-tighter text-[#1f1b16] uppercase">
            {{ data.title }}
          </h2>
          <p class="text-[10px] font-bold text-[#3a332c]/40 uppercase tracking-[0.2em]">
            Resumen de cuenta
          </p>
        </div>

        <div class="space-y-3 rounded-3xl bg-[#f6f1eb]/50 px-5 py-5 border border-black/[0.02]">
          <div class="flex items-center justify-between text-sm font-medium text-[#3a332c]/60">
            <span>Subtotal</span>
            <span class="font-bold text-[#1f1b16] tabular-nums">
              $ {{ data.itemsSubtotal | number: '1.2-2' }}
            </span>
          </div>

          @if (data.discountAmount > 0) {
            <div class="flex items-center justify-between text-sm font-medium text-emerald-700">
              <span>Descuentos</span>
              <span class="font-bold text-emerald-600 tabular-nums">
                - $ {{ data.discountAmount | number: '1.2-2' }}
              </span>
            </div>
          }

          <div class="flex items-center justify-between text-sm font-medium text-[#3a332c]/60">
            <span>Propina</span>
            <span class="font-bold text-green-600 tabular-nums">
              + $ {{ data.tipAmount | number: '1.2-2' }}
            </span>
          </div>

          <div class="flex items-center justify-between gap-4 border-t border-black/5 pt-4 mt-2">
            <span class="text-sm font-black text-[#1f1b16] uppercase tracking-wider text-xs"
              >Total Final</span
            >
            <span class="text-3xl font-black text-[#eb6608] tracking-tighter tabular-nums">
              $ {{ data.totalAmount | number: '1.2-2' }}
            </span>
          </div>
        </div>
      </section>

      <div class="space-y-4">
        <p class="text-[10px] font-bold uppercase tracking-[0.3em] text-[#3a332c]/30 px-2">
          Detalle por persona
        </p>
        <app-public-bill-split-summary-card
          [currency]="data.currency"
          [participants]="data.participants"
        />
      </div>

      <div class="pt-12 pb-8 flex flex-col items-center gap-4">
        <div class="h-px w-12 bg-black/5"></div>
        <div class="text-center space-y-1">
          <p class="text-[10px] font-bold uppercase tracking-widest text-[#3a332c]/30">
            ¿Querés dividir otra cuenta?
          </p>
          <button
            (click)="goToSplit()"
            class="inline-flex items-center gap-2 rounded-xl border border-black/10 px-6 py-3 text-xs font-bold text-[#1f1b16] transition-all active:scale-95 hover:bg-black/[0.02]"
          >
            Crear mi propia división en Dinno
          </button>
        </div>

        <app-public-bill-split-footer />

        <div class="pt-8 flex flex-col items-center gap-4"></div>

        <p class="text-[9px] font-medium text-[#3a332c]/20 uppercase tracking-tighter">Dinno</p>
      </div>
    }
  </main>
</div>
